/**
 * Кастомная иконка «Дом» для нижнего меню
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function HomeIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8832 16.6524H9.11777C8.7073 16.6524 8.37417 16.3324 8.37417 15.9381C8.37417 15.5438 8.7073 15.2238 9.11777 15.2238H14.8832C15.2937 15.2238 15.6268 15.5438 15.6268 15.9381C15.6268 16.3324 15.2937 16.6524 14.8832 16.6524ZM19.1872 6.43619C18.8273 6.13143 18.4178 5.78667 17.93 5.35333C17.7089 5.1819 17.467 4.98571 17.2102 4.7781C15.7627 3.60571 13.7797 2 11.9723 2C10.1856 2 8.33054 3.51619 6.84036 4.73429C6.56473 4.95905 6.30695 5.17048 6.04421 5.37524C5.58219 5.78667 5.17271 6.13238 4.81181 6.4381C2.44517 8.43905 2 8.96381 2 13.6314C2 22 4.51933 22 12 22C19.4797 22 22 22 22 13.6314C22 8.96286 21.5548 8.4381 19.1872 6.43619Z"
        fill="currentColor"
      />
    </svg>
  );
}